import styled from 'styled-components';

export const FiltersSelectorsStyled = styled.div`
  .filtersSelectors {    
    &__container{
      display: flex;
      flex-direction: row;
      column-gap: 8px;
      justify-content: space-between;
    }
    
    &__country, &__appAndSite, &__creativeSize, &__publisher, &__supplySource, &__sourceType {
        width: 100%;
    }
  }
`;
